import React, { useState, useEffect } from 'react';
import { ModalWrapper, ButtonGroup } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { Form, Button, Space, message, Select, Upload } from 'antd';
import { CheckOutlined } from '@ant-design/icons'
import { UploadOutlined, DownloadOutlined, PaperClipOutlined } from '@ant-design/icons'
import { UploadFile } from 'antd/lib/upload/interface';
import * as XLSX from 'xlsx';
import { CompanySelectBox, CrmSelectBox, DatePicker } from 'components/atoms'
import { dateFormat } from 'utils/date-utils';
import axios from 'axios';
import { endpoints } from 'services';
import { SERVER_URL } from 'commons/constants';
import { useRefCode } from 'hooks';

export interface StudentExcelUploadModalProps extends PopupProps {
    lectureInfo: LectureInfoDto;
}

const StudentExcelUploadModal = ({ 
    isOpen, 
    onClose, 
    lectureInfo}: StudentExcelUploadModalProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */  
    const [isUpload, setIsUpload] = useState<boolean>(false);    
    const [uploadFileList, setUploadFileList] = useState<UploadFile[]>([]);
    const [companySrl, setCompanySrl] = useState<number>(0);
    const [eduCrmSrl, setEduCrmSrl] = useState<number>(0);
    const [eduCrmSrlN, setEduCrmSrlN] = useState<number>(0);
    const [eduCrmInfo, setEduCrmInfo] = useState<CrmCodeListDto>();
    const [accCrmSrl, setAccCrmSrl] = useState<number>(0);
    const [accCrmSrlN, setAccCrmSrlN] = useState<number>(0);
    const [accCrmInfo, setAccCrmInfo] = useState<CrmCodeListDto>();
    const [companyName, setCompanyName] = useState<string>('');  
    const [companyInfo, setCompanyInfo] = useState<CompanyCodeListDto>();  
    const [uploadStudents, setUploadStudents] = useState<AppStudentExcelItemDto[]>([]);
    const [salePrice, setSalePrice] = useState<number>(0);
    const [routeOption, setSouteOption] = useState<any[]>([]);

    // const [routeOption] = useState<any[]>(
    //     [
    //         {value:'HSG 이메일/뉴스레터', label: 'HSG 이메일/뉴스레터'},
    //         {value:'AI 검색', label: 'AI 검색'},
    //         {value:'네이버 검색', label: '네이버 검색'},
    //         {value:'구글 검색', label: '구글 검색'},
    //         {value:'블로그', label: '블로그'},
    //         {value:'세미나/설명회', label: '세미나/설명회'},
    //         {value:'칼럼/도서', label: '칼럼/도서'},
    //         {value:'지인 추천', label: '지인 추천'},
    //         {value:'HSG를 이전부터 알고 있었음', label: 'HSG를 이전부터 알고 있었음'},
    //         {value:'기타', label: '기타'},
    //     ]        
    // )
  /* ======================================================
  * hooks
  * ====================================================== */
  const { refCodeList: howknowList } = useRefCode({field:'how_know'});  

   /* ======================================================
   * variables
   * ====================================================== */
  const [form] = Form.useForm();

   /* ======================================================
   * events
   * ====================================================== */
   const readExcel = async (file: File) => {
    const fileReader = new FileReader();
    fileReader.readAsArrayBuffer(file);
    fileReader.onload = (e: ProgressEvent<FileReader>) => {
      if (!e.target) return;
      const bufferArray = e.target.result;
      const fileInformation = XLSX.read(bufferArray, {
        type: 'buffer',
        cellText: false,
        cellDates: true,
      });
      const sheetName = fileInformation.SheetNames[0];
      const rawData = fileInformation.Sheets[sheetName];
      const data = XLSX.utils.sheet_to_json(rawData);
      
      let chk = true;
      let isRead = false;
      const students : AppStudentExcelItemDto[] = [];
      data.forEach((item:any) => {
        if (item[Object.keys(item)[0]] === 'NO') {
            isRead = true;    
        } else if (isRead) {
            if (!!item.__EMPTY_1 || 
                !!item.__EMPTY_2 ||
                !!item.__EMPTY_3 ||
                !!item.__EMPTY_4 ||
                !!item.__EMPTY_5 ||
                !!item.__EMPTY_6 ||
                !!item.__EMPTY_7 ||
                !!item.__EMPTY_8 ||
                !!item.__EMPTY_9) {

                if (!item.__EMPTY_1 || 
                    !item.__EMPTY_2 ||
                    !item.__EMPTY_3 ||
                    !item.__EMPTY_4 ||
                    !item.__EMPTY_5 ||
                    !item.__EMPTY_6 ||
                    !item.__EMPTY_7 ||
                    !item.__EMPTY_8 ||
                    !item.__EMPTY_9) {
                    chk = false;
                    return true;
                } else {
                    // 교육생 정보 담아주기
                    students.push({
                        department: String(item.__EMPTY_2),
                        name_kor: String(item.__EMPTY_3),
                        position: String(item.__EMPTY_4),
                        duty: String(item.__EMPTY_5),
                        age: String(item.__EMPTY_6),
                        sex: String(item.__EMPTY_7),
                        phone: String(item.__EMPTY_8),
                        email: String(item.__EMPTY_9),
                        name_eng: String(item.__EMPTY_10),
                        job: '',
                        role: '',
                    })
                }
            } else {
                return true;
                
            }
        }
      });
      if (chk) {
        setUploadStudents(students);
        if (lectureInfo.lecture_sale_yn === 'Y') {
            setSalePrice(lectureInfo.lecture_price * students.length * 0.9)
        } else {
            setSalePrice(lectureInfo.lecture_price * students.length)
        }
        
      } else {
        alert("등록하신 신청서의 \n기업명/부서/성명/직급/휴대폰/이메일 중 \n일부 항목이 정상적으로 기입되지 않았습니다.\n확인 후 다시 업로드해주시기 바랍니다.");
        setUploadFileList([]);
      }

      
      //data && setUploadedFileData(mappingDataToTable(data as any[]));
     };
   };

   const onInsertCompleted = (value: number, field: string) => {
    if (field === 'edu_crm_srl') {
        setEduCrmSrlN(value)
    } else {
        setAccCrmSrlN(value)   
    }
   }

   const onSubmit = (e) => {    
    if (uploadStudents.length === 0) {
        alert("등록할 교육생이 없습니다.")
        return true;
    }

    setIsUpload(true);
    const unitPrice = (lectureInfo.lecture_sale_yn==='Y' && uploadStudents.length > 1)?lectureInfo.lecture_price*0.9:lectureInfo.lecture_price;
    const ajaxForm = new FormData();
    ajaxForm.append('b2c_group_srl', lectureInfo.id.toString());
    ajaxForm.append('company', companyName);
    ajaxForm.append('company_srl', companySrl.toString());
    ajaxForm.append('price', lectureInfo.lecture_price.toString());
    ajaxForm.append('unit_price', unitPrice.toString());
    ajaxForm.append('unit_price_dc', (lectureInfo.lecture_price-unitPrice).toString());
    ajaxForm.append('tot_price', (lectureInfo.lecture_price*uploadStudents.length).toString());
    ajaxForm.append('sale_price', (unitPrice*uploadStudents.length).toString());
    ajaxForm.append('pay_amt', (unitPrice*uploadStudents.length*1.1).toFixed(0));
    ajaxForm.append('ebill_yn', e.ebill_yn);
    ajaxForm.append('ebill_etc', form.getFieldValue("ebill_etc") ? dateFormat(form.getFieldValue("ebill_etc"), 'YYYY-MM-DD'):'null');
    ajaxForm.append('route', e.route);
    ajaxForm.append('student_cnt', uploadStudents.length.toString());
    ajaxForm.append('edu_crm_srl', eduCrmSrl.toString());
    ajaxForm.append('edu_name', String(eduCrmInfo?.label));
    ajaxForm.append('edu_email', String(eduCrmInfo?.email));
    ajaxForm.append('edu_position', String(eduCrmInfo?.position));
    ajaxForm.append('edu_phone', String(eduCrmInfo?.phone));
    ajaxForm.append('edu_phone2', String(eduCrmInfo?.tel));
    ajaxForm.append('acc_crm_srl', accCrmSrl.toString());
    ajaxForm.append('acc_name', String(accCrmInfo?.label));
    ajaxForm.append('acc_phone', String(accCrmInfo?.phone));
    ajaxForm.append('acc_email', String(accCrmInfo?.email));

    uploadStudents.forEach((student, index) => {
        ajaxForm.append('students['+index+'].department',student.department);
        ajaxForm.append('students['+index+'].name_kor',student.name_kor);
        ajaxForm.append('students['+index+'].position',student.position);
        ajaxForm.append('students['+index+'].duty',student.duty);
        ajaxForm.append('students['+index+'].age',student.age);
        ajaxForm.append('students['+index+'].sex',student.sex);
        ajaxForm.append('students['+index+'].phone',student.phone);
        ajaxForm.append('students['+index+'].email',student.email);
        ajaxForm.append('students['+index+'].name_eng',student.name_eng);
    });  

    axios.post(
        SERVER_URL + endpoints.b2c.student.upload,
        ajaxForm
      )
        .then((res) => {
            switch (res.data.code) {
                case 200:
                    message.info('정보가 등록 되었습니다.', 1);
                    onClose?.(true);
                break;
                default:  
                    message.error('등록중 오류 발생하였습니다.', 1);
                break;
            };
            setIsUpload(false);
        })
        .catch(() => {
          message.error('에러가 발생했습니다.', 1);
          setIsUpload(false);
        });

   }
  /* ======================================================
   * effects
   * ====================================================== */
  useEffect(() => {
    const options = howknowList?.sort((a, b)=>a.display_sort - b.display_sort).filter((item) => item.status_type === 'AV').map((item) => {return {value: item.value, label: item.value}}) || [];
    setSouteOption(options);
  }, [howknowList]);

    return (
    <ModalWrapper open={isOpen} onCancel={onClose} width={500} title={'교육생 단체등록'} closable>
        <Space direction='vertical' style={{width:'100%'}}>
            <h4 style={{marginBottom:'0px'}}>{lectureInfo.lecture_title}</h4>
            <label ><CheckOutlined /> 단체등록</label>
            <Form
                form={form}
                name="StudentInfo"
                layout="horizontal"  
                labelCol={{ flex: '120px' }}
                onFinish={onSubmit}
                style={{width:'100%'}}
                autoComplete="off"
            >
                <Form.Item label={'단체 신청서 작성'}>
                    <a href="/assets/excel/HSG_공개교육_단체신청서양식.xlsx"><Button icon={<DownloadOutlined />}>신청서 다운</Button></a>     
                </Form.Item> 
                <Form.Item label={'신청서 업로드'}>
                    <Upload
                        fileList={uploadFileList}
                        onChange={({ fileList: list }) => {
                            setUploadFileList(list);
                        }}   
                        beforeUpload={(file, filelist) => {
                            readExcel(file);
                        }}                                           
                        customRequest={() => true}
                        maxCount={1}
                        accept=".xlsx"
                        iconRender={()=><PaperClipOutlined />}
                    >
                        <Button icon={<UploadOutlined />} style={{fontSize:'12px'}}>등록</Button>
                    </Upload>        
                </Form.Item> 
                <Form.Item label={'교육생수'}>
                    <label>{uploadStudents.length}명</label>
                </Form.Item>  
                <Form.Item label={'총교육비 (vat포함)'}>
                    <label>{salePrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} ({(salePrice*1.1).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")})</label>
                </Form.Item>  
                <Form.Item name="company_srl" label={'고객사(기업명)'} rules={[{ required: true, message: '' }]}>
                    <CompanySelectBox required={true} form={form} company_srl={companySrl} onSelected={(value, option) => {setCompanySrl(Number(value)); setCompanyName(option.label); setCompanyInfo(option)}} />
                </Form.Item>  
                <Form.Item name="edu_crm_srl" label={'교육담당자'} rules={[{ required: true, message: '' }]}>
                    <CrmSelectBox 
                        form={form} 
                        company={companySrl} 
                        company_name={companyName} 
                        field_name={'edu_crm_srl'}
                        onInsertCompleted={onInsertCompleted}
                        insertCrmId={accCrmSrlN}
                        onSelected={(value, option) => {
                            setEduCrmSrl(Number(value)); 
                            setEduCrmInfo(option);
                        }}
                    />                     
                </Form.Item>  
                <Form.Item name="acc_crm_srl" label={'결제담당자'} rules={[{ required: true, message: '' }]}>
                    <CrmSelectBox 
                        form={form} 
                        company={companySrl} 
                        company_name={companyName} 
                        field_name={'acc_crm_srl'}
                        onInsertCompleted={onInsertCompleted}
                        insertCrmId={eduCrmSrlN}
                        onSelected={(value, option) => {
                            setAccCrmSrl(Number(value)); 
                            setAccCrmInfo(option);                          
                        }}
                    />                     
                </Form.Item>  
                <Form.Item name={'ebill_yn'}  label={'결제방법'} rules={[{ required: true, message: '' }]}>
                    <Form.Item name={'ebill_yn'} style={{ width:'150px', display: 'inline-block', marginRight: '5px' }}>
                        <Select 
                            placeholder="결제방법 선택" 
                            style={{width:"150px"}}
                            options={[
                                {value:'C', label: '선납금'},
                                {value:'Y', label: '세금계산서'},
                                {value:'N', label: '카드'},
                                {value:'P', label: '포인트'},
                                {value:'B', label: '현금영수증'},
                            ]} />                   
                    </Form.Item> 
                    <Form.Item name={'ebill_etc'} style={{ width:'calc(100% - 150px - 10px)', display: 'inline-block', marginRight: '5px' }}>
                        <DatePicker showTime={false} format="YYYY-MM-DD" />                 
                    </Form.Item> 
                </Form.Item>
                <Form.Item name={'route'} label={'신청경로'} rules={[{ required: true, message: '' }]}>
                    <Select 
                            placeholder="신청경로 선택" 
                            options={routeOption} />               
                </Form.Item>  
                <ButtonGroup className={'buttonsWrapper'}>
                    <Button onClick={onClose} style={{marginRight: "5px"}} disabled={isUpload}>닫기</Button>                    
                    <Button htmlType="submit"  type="primary" disabled={isUpload}>{'등록'}</Button>                    
                </ButtonGroup> 
            </Form>
        </Space>        
    </ModalWrapper>  
    )    
};

export default StudentExcelUploadModal;    